
import { inject, Injectable } from "@angular/core";
import { StoredMarketFilterModel } from "@models/map/market-filter.model";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IResidenceSaleInArea, SaleInArea } from "src/models/estate/IResidenceSaleInArea";
import { IResponseWrapper } from "src/models/ResponseWrapper.model";
import { FilterId, FilterOverview, FilterType } from "src/models/shared/filter.model";
import { HttpDataService } from "../httpdata.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class StoredFiltersDataService {
    readonly dataService = inject(HttpDataService);
    private readonly http = inject(HttpClient);
    getFilterUrl = `${environment.apiUrl}/Filter`;
    createOrChangeFilterUrl = `${environment.apiUrl}/Filter/%`;
    getFilterOverviewUrl = `${environment.apiUrl}/Filter/Overview`;
    getUserFilterUrl = `${environment.apiUrl}/Filter/UserFilter`;
    createUserFilterUrl = `${environment.apiUrl}/Filter/CreateUserFilter`;
    getSalesForUnitsUrl = `${environment.apiUrl}/Sales/ResidenceSalesForUnits`;
    getPropertiesForUnitsUrl = `${environment.apiUrl}/Sales/PropertiesForUnits`;

    createFilter(filter: StoredMarketFilterModel): Observable<FilterId> {
        return this.dataService.post<IResponseWrapper<FilterId>>(this.getFilterUrl, filter)
            .pipe(map((response: {data: FilterId}) => response.data));
    }

    updateFilter(filterId: number, updated: StoredMarketFilterModel): Observable<FilterId> {
        return this.dataService.put<IResponseWrapper<FilterId>>(this.createOrChangeFilterUrl.replace("%", filterId.toString()), updated)
            .pipe(map((response: {data: FilterId}) => response.data));
    }

    deleteFilter(filterId: number): Observable<FilterId> {
        return this.dataService.delete<FilterId>(
            this.createOrChangeFilterUrl.replace("%", filterId.toString()), {}
        ).pipe(
            map((response: any) => response.body as FilterId)
        );
    }

    getFilter(filterId: number): Observable<StoredMarketFilterModel> {
        console.log(filterId);
        return this.http.get<IResponseWrapper<StoredMarketFilterModel>>(this.createOrChangeFilterUrl.replace("%", filterId.toString()), {})
            .pipe(map((response: {data: StoredMarketFilterModel}) => response.data));
    }

    createUserFilter(filter: StoredMarketFilterModel): Observable<FilterId> {
        return this.dataService.post<IResponseWrapper<FilterId>>(this.createUserFilterUrl, filter)
            .pipe(map((response: {data: FilterId}) => response.data));
    }

    getUserFilter(filterType: FilterType): Observable<StoredMarketFilterModel | null> {
        return this.dataService.get<IResponseWrapper<StoredMarketFilterModel>>(`${this.getUserFilterUrl}?filterType=${filterType.toString()}`, {})
            .pipe(map((response) => response.data ?? null));
    }

    getFilterOverview(filterType: FilterType): Observable<FilterOverview[]> {
        return this.dataService.get<IResponseWrapper<FilterOverview[]>>(`${this.getFilterOverviewUrl}?filterType=${filterType.toString()}`, {})
            .pipe(map((response) => response.data));
    }

    getSalesForUnits(unitIds: number[]): Observable<SaleInArea[]> {
        return this.dataService.post<IResponseWrapper<IResidenceSaleInArea>>(this.getSalesForUnitsUrl, unitIds)
            .pipe(map((response) => response.data?.sales));
    }

    getPropertiesForUnits(unitIds: number[]): Observable<SaleInArea[]> {
        return this.dataService.post<IResponseWrapper<IResidenceSaleInArea>>(this.getPropertiesForUnitsUrl, unitIds)
            .pipe(map((response) => response.data?.sales));
    }
}
